<div class="min-h-screen flex flex-column surface-ground">
  <div class="flex-grow-1 flex flex-column relative z-0">
    <router-outlet></router-outlet>
  </div>

  <footer class="surface-900 text-white p-4 text-center z-5">
    <p class="m-0">&copy; 2026 Sistema Provincial de Infracciones</p>
  </footer>
</div>
